<template>
    <div class="tep-nagr-system-wrap">
        <div class="tep-nagr-system-title">
            {{ meta.title }}
        </div>
        <div class='tep-nagr-system-grid'>
            <dx-button hint="Выбрать" width='32px' height='32px' @click="openPopup">
                <img :src="'/infoenergo/assets/tep/tep-cards/arrow-right.svg'" alt='' class='w-full h-full'>
            </dx-button>
            <ai-form-text-box-readonly
                class="tep-nagr-system-input-name tep-nagr-system-no-label"
                :meta='{fieldNameText: meta.fieldNameText, fieldNameId: meta.fieldNameId}'
                :server-data='userData'
            />
        </div>
        <dx-popup
            ref="popupRef"
            height="95%"
            :title="meta.title"
            :drag-enabled="true"
            :hide-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :visible="popupVisible"
            @hiding='onClose'
        >
            <ai-tree-list-edit
                ref="refData"
                :meta="metaData"
                :to-remove-toolbar-items-names="removeToolbarBtnsList"
                @toolbar-button-click="onToolbarClick"
                @cell-click='onCellClick'
            ></ai-tree-list-edit>
        </dx-popup>
    </div>
</template>
<script>
export default {
    name: 'tep-pv-harp-par',
};
</script>
<script setup>
import { inject, onMounted, ref } from 'vue';
import { DxButton, DxPopup } from 'devextreme-vue';
import AiFormTextBoxReadonly from '@/components/card-component/ai-form-text-box-readonly.vue';
import AiTreeListEdit from '@/components/ai-tree-list-edit/ai-tree-list-edit.vue';
import tepService from '@/service/tep-service';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    serverData: {
        type: Object,
        default: () => {
        },
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const popupRef = ref(null);
const userData = inject('userData');
const popupVisible = ref(false);
const refData = ref(null);
const selectedKodHarp = ref(null);
const isKodChoice = ref(false);

onMounted(async () => {
    await refData.value?.setDataSource();
});

const openPopup = async () => {
    let focusKod = -1;
    if(userData.value['kod_harp']) {
        focusKod = userData.value['kod_harp'];
    }
    else {
        const dataTree = refData.value?.getTreeListDataSource();
        focusKod =  dataTree?.length ? dataTree[0].kod_harp : null;
    }

    refData.value?.treeListInstance.option('focusedRowKey', focusKod);
    popupVisible.value = true;
}

const onClose = (e) => {
    if (popupVisible.value) {
        e.cancel = true;
        beforeNsiClose();
    }
}

const onToolbarClick = async (event) => {
    const componentName = event?.item?.component?.name;
    if (componentName === 'choice') {
        isKodChoice.value = true;
        await beforeNsiClose();
    }
};

const beforeNsiClose = async () => {
    const canClose = await refData.value?.checkBeforeClose();
    if (!canClose) return false;
    const dataTree = await refData.value?.getTreeListDataSource();
    const choiceItem = await dataTree.find(item => {
        return item.kod_harp === selectedKodHarp.value;
    });
    onChooseKod(choiceItem);
};

const onChooseKod = (async (choiceItem) => {
    if(isKodChoice.value) {
        userData.value.kod_harp = choiceItem?.kod_harp;
        let fullName = '';
        fullName = await tepService.getHarpName(choiceItem.kod_harp);
        let nameInput = fullName ? fullName : choiceItem.name;
        userData.value.harp_name =nameInput;
        isKodChoice.value = false;
        if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
    }
    popupVisible.value = false;
    selectedKodHarp.value = null;
    popupRef.value?.instance.hide();
});

const onCellClick= async (event) => {
    selectedKodHarp.value = event.key;
};

const removeToolbarBtnsList = ['find-prev', 'find', 'find-start', 'find-next', 'expandOrCollapseButton',
    'copy', 'moveTo', 'moveSave', 'edit', 'searchPanel', 'export', 'show-column-chooser'];

const metaData = {
    'keyExpr': 'kod_harp',
    'parentIdExpr': 'kod_r',
    'selectionMode': 'single',
    'selectButtonMode': 'single',
    'columns': [
        {
            'name': 'kod_harp',
            'caption': 'kod_harp',
            'dataField': 'kod_harp',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'kod_r',
            'caption': 'kod_r',
            'dataField': 'kod_r',
            'allowEditing': false,
            'width': 250,
            'index': 2,
            'visible': false,
        },
        {
            'name': 'name',
            'caption': 'Наименование',
            'dataField': 'name',
            'allowEditing': true,
            'width': '100%',
            'index': 3,
            'visible': true,
        },
        {
            "name": "empty",
            "caption": "",
            "dataField": "empty",
            "allowEditing": false,
            'width': 30,
            'minWidth': 30,
            "index": 5,
            "visible": true
        }
    ],
    'api': {
        'select': 'tep-grid./tep/qs-harp/select/get',
        'save': 'tep-grid./tep/qs-harp/save/set',
    },
    'viewId': 'view-qs-harp',
};
</script>
<style scoped>
.tep-nagr-system-title {
    padding: 0 0 4px;
}
.tep-nagr-system-grid {
    display: grid;
    gap: 8px;
    grid-template-columns: 32px 1fr;
}

.tep-nagr-system-no-label :deep(.dx-field-label) {
    display: none;
}
</style>
